<template>
  <div class="promo-shell">
    <PromoForm />
    <PromoGallery />
  </div>

  <div v-if="workbench.lightbox.show" class="lightbox" @click="workbench.closeLightbox">
    <img :src="workbench.lightbox.url" alt="preview" @click.stop />
    <button class="lightbox-close" @click.stop="workbench.closeLightbox">×</button>
  </div>
</template>

<script setup>
import PromoForm from '@/components/promo/PromoForm.vue'
import PromoGallery from '@/components/promo/PromoGallery.vue'
import { useWorkbenchStore } from '@/stores/useWorkbenchStore'

const workbench = useWorkbenchStore()
</script>
